const keyMirror = require("keymirror");

export const EntriesConstants = keyMirror({
  FETCH_ENTRIES: undefined,
  EXPORTS_ENTRIES: undefined,
  FETCH_STATISTICS: undefined
});
